/* tslint:disable */
/* eslint-disable */
/**
 * Assisted Webservices
 * Enables agents to provide real-time support to customers. For example, agents are able to find a customer account or cart, bind anonymous carts to customer accounts, and provide different customer lists relative to different business applications.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';
import type { B2BApprovalProcess } from './B2BApprovalProcess';
import {
    B2BApprovalProcessFromJSON,
    B2BApprovalProcessFromJSONTyped,
    B2BApprovalProcessToJSON,
} from './B2BApprovalProcess';
import type { B2BCostCenterShallow } from './B2BCostCenterShallow';
import {
    B2BCostCenterShallowFromJSON,
    B2BCostCenterShallowFromJSONTyped,
    B2BCostCenterShallowToJSON,
} from './B2BCostCenterShallow';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * Representation of an organizational unit
 * @export
 * @interface B2BUnit
 */
export interface B2BUnit {
    /**
     * Boolean flag of whether Organizational Unit is active
     * @type {boolean}
     * @memberof B2BUnit
     */
    active?: boolean;
    /**
     * Identifier of the organizational unit
     * @type {string}
     * @memberof B2BUnit
     */
    uid: string;
    /**
     * Name of the organizational unit
     * @type {string}
     * @memberof B2BUnit
     */
    name?: string;
    /**
     * 
     * @type {B2BUnit}
     * @memberof B2BUnit
     */
    parentOrgUnit?: B2BUnit;
    /**
     * 
     * @type {B2BApprovalProcess}
     * @memberof B2BUnit
     */
    approvalProcess?: B2BApprovalProcess;
    /**
     * Addresses of the organizational unit node
     * @type {Array<Address>}
     * @memberof B2BUnit
     */
    addresses?: Array<Address>;
    /**
     * Approvers of the organizational unit node
     * @type {Array<User>}
     * @memberof B2BUnit
     */
    approvers?: Array<User>;
    /**
     * Managers of the organizational unit node
     * @type {Array<User>}
     * @memberof B2BUnit
     */
    managers?: Array<User>;
    /**
     * Administrators of the organizational unit node
     * @type {Array<User>}
     * @memberof B2BUnit
     */
    administrators?: Array<User>;
    /**
     * Customers of the organizational unit node
     * @type {Array<User>}
     * @memberof B2BUnit
     */
    customers?: Array<User>;
    /**
     * The cost centers of the organizational unit node
     * @type {Array<B2BCostCenterShallow>}
     * @memberof B2BUnit
     */
    costCenters?: Array<B2BCostCenterShallow>;
    /**
     * Boolean flag of default B2BUnit of the given User.
     * @type {boolean}
     * @memberof B2BUnit
     */
    isDefaultB2BUnit?: boolean;
}

/**
 * Check if a given object implements the B2BUnit interface.
 */
export function instanceOfB2BUnit(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "uid" in value;

    return isInstance;
}

export function B2BUnitFromJSON(json: any): B2BUnit {
    return B2BUnitFromJSONTyped(json, false);
}

export function B2BUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): B2BUnit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': !exists(json, 'active') ? undefined : json['active'],
        'uid': json['uid'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'parentOrgUnit': !exists(json, 'parentOrgUnit') ? undefined : B2BUnitFromJSON(json['parentOrgUnit']),
        'approvalProcess': !exists(json, 'approvalProcess') ? undefined : B2BApprovalProcessFromJSON(json['approvalProcess']),
        'addresses': !exists(json, 'addresses') ? undefined : ((json['addresses'] as Array<any>).map(AddressFromJSON)),
        'approvers': !exists(json, 'approvers') ? undefined : ((json['approvers'] as Array<any>).map(UserFromJSON)),
        'managers': !exists(json, 'managers') ? undefined : ((json['managers'] as Array<any>).map(UserFromJSON)),
        'administrators': !exists(json, 'administrators') ? undefined : ((json['administrators'] as Array<any>).map(UserFromJSON)),
        'customers': !exists(json, 'customers') ? undefined : ((json['customers'] as Array<any>).map(UserFromJSON)),
        'costCenters': !exists(json, 'costCenters') ? undefined : ((json['costCenters'] as Array<any>).map(B2BCostCenterShallowFromJSON)),
        'isDefaultB2BUnit': !exists(json, 'isDefaultB2BUnit') ? undefined : json['isDefaultB2BUnit'],
    };
}

export function B2BUnitToJSON(value?: B2BUnit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'uid': value.uid,
        'name': value.name,
        'parentOrgUnit': B2BUnitToJSON(value.parentOrgUnit),
        'approvalProcess': B2BApprovalProcessToJSON(value.approvalProcess),
        'addresses': value.addresses === undefined ? undefined : ((value.addresses as Array<any>).map(AddressToJSON)),
        'approvers': value.approvers === undefined ? undefined : ((value.approvers as Array<any>).map(UserToJSON)),
        'managers': value.managers === undefined ? undefined : ((value.managers as Array<any>).map(UserToJSON)),
        'administrators': value.administrators === undefined ? undefined : ((value.administrators as Array<any>).map(UserToJSON)),
        'customers': value.customers === undefined ? undefined : ((value.customers as Array<any>).map(UserToJSON)),
        'costCenters': value.costCenters === undefined ? undefined : ((value.costCenters as Array<any>).map(B2BCostCenterShallowToJSON)),
        'isDefaultB2BUnit': value.isDefaultB2BUnit,
    };
}

